import { Injectable } from "@angular/core";
import { ComponentTool } from "../interfaces/componenttool";

@Injectable()
export class CookieDisclaimerService {
    private static readonly COOKIE_DISCLAIMER_ACCEPTANCE_FIELD = 'isCookieDisclaimerAccepted_';

    public getCookie(compTool: ComponentTool): Cookie | null {
        return JSON.parse(localStorage.getItem(this.getCookieKey(compTool)) ?? 'null') as Cookie;
    }

    public setCookie(compTool: ComponentTool, cookie: Cookie): void {
        localStorage.setItem(this.getCookieKey(compTool), JSON.stringify(cookie));
    }

    public areAnalyticCookiesEnabled(compTool: ComponentTool): boolean {
        return this.getCookie(compTool)?.analytics ?? false;
    }

    private getCookieKey(compTool: ComponentTool): string {
        return CookieDisclaimerService.COOKIE_DISCLAIMER_ACCEPTANCE_FIELD + ComponentTool[compTool].toString();
    }
}